import styled from '@xstyled/styled-components'

export const StyledEmbedTextAreaContainer = styled.div({})
